import React, { FC } from 'react';
import { MyVehicleItem } from 'api/vehicles';
import { FirstPlateSeparatorIcon } from 'common/icons';
import clsx from 'classnames';

import styles from './plate.module.scss';

export const BikePlate: FC<{ bike: MyVehicleItem }> = ({ bike }) => {
  // @ts-ignore
  const letters = bike.plate.match(/[a-zA-Z]+/g).join('');
  // @ts-ignore
  const digits = +bike.plate.match(/[0-9]+/g).join('');

  return (
    <div className={clsx(styles.container, styles.bike)}>
      <span>CHILE</span>

      <span>
        {letters} <FirstPlateSeparatorIcon /> {digits}
      </span>
    </div>
  );
};
